import { FlipCard } from '../styled'

export const AnimatedCard = ({
  animation,
  digit,
  background,
  textStyle = {},
}) => (
  <FlipCard className={animation} background={background} {...textStyle}>
    <span>{digit}</span>
  </FlipCard>
)
